<div class="row pt-3 pb-3 coupon-wrap">
  <div class="col-12">
    <form [formGroup]="form"
      (ngSubmit)="submitForm()">
      <p translate>Enter coupon code</p>
      <div class="d-flex">
        <input type="text"
          class="form-control"
          [ngClass]="{'error': errorMessage}"
          formControlName="coupon"
          [value]="useOneCoupon && coupons?.length ? coupons[0]['coupon_code'] : ''"
          >
        <span class="space">&nbsp;</span>
        <button spinEl
          [spinning]="submitSpinner"
          [disabled]="!form.valid"
          type="submit"
          class="btn btn-light btn-outline {{useOneCoupon && coupons?.length ? 'btn-link disabled' : ''}}"
          translate>{{useOneCoupon && coupons?.length ? 'Applied' : 'Send'}}
        </button>
      </div>
    </form>
    <div class="error">{{errorMessage}}</div>
    <ul class="list-unstyled m-2">
      @for (coupon of coupons; track coupon) {
        <li>
          <button spinEl  (click)="removeCoupon(coupon)" class="btn-link cursor-pointer">
            <i class="ion-icon ion-close ml-2 mr-2 ion-sm" style="zoom:0.8">
            </i>
          </button>
          <span>{{coupon['coupon_code']}}</span> @if (coupon['get_freeship'] == '1') {
          <span class="m-3" translate>Shipping type coupon</span>
        }
      </li>
    }
  </ul>
</div>
</div>
